import { render, staticRenderFns } from "./match_making.vue?vue&type=template&id=1efd40af&scoped=true&"
import script from "./match_making.vue?vue&type=script&lang=js&"
export * from "./match_making.vue?vue&type=script&lang=js&"
import style0 from "./match_making.vue?vue&type=style&index=0&id=1efd40af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd40af",
  null
  
)

export default component.exports